"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadComponentPadCount = void 0;
class KicadComponentPadCount {
    static deriveNumPads(footprints) {
        const padCounts = footprints.map((footprint) => footprint.pads.length);
        if (padCounts.length === 0) {
            return 0;
        }
        if (padCounts.length === 1) {
            return padCounts[0];
        }
        return padCounts;
    }
}
exports.KicadComponentPadCount = KicadComponentPadCount;
//# sourceMappingURL=KicadComponentPadCount.js.map